import { DownloadAndroidApp } from 'components/DownloadAndroidApp';

import { ScDownloadButtons } from './styled';

export const DownloadButtons = () => (
  <ScDownloadButtons>
    <DownloadAndroidApp />
  </ScDownloadButtons>
);
